const customCategory = (categories, newTitle) => {
  const generateUniqueTitle = title => {
    let uniqueTitle = title;
    let counter = 1;

    while (
      categories.some(item => {
        const itemTitle = item._income_heads
          ? item._income_heads.title
          : item.title;
        return itemTitle === uniqueTitle;
      })
    ) {
      uniqueTitle = `${title} ${++counter}`;
    }

    return uniqueTitle;
  };

  const finalTitle = generateUniqueTitle(newTitle);

  const newItem = {
    id: null,
    created_at: Date.now(),
    _income_heads: { title: finalTitle },
    default: false,
    custom: true,
  };

  categories.push(newItem);

  return categories;
};

export default customCategory;
